import React, { useContext, useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FormGroup, Input, Label } from "reactstrap";
import UserContext from "../auth/UserContext";
import { useAppSettings } from "../settings/AppSettingsContext";
import { resolveBrandLogoUrl } from "../settings/logoAssets";
import ValetApi from "../api/Api";
import "./NavHead.css";

const GARAGE_FILTERS_STORAGE_KEY = "garageList.filters.v1";

function readGarageFilterSummary() {
    try {
        const raw = window.localStorage.getItem(GARAGE_FILTERS_STORAGE_KEY);
        if (!raw) return { viewMode: "operational", sortBy: "default" };
        const parsed = JSON.parse(raw);
        return {
            viewMode: parsed?.viewMode || "operational",
            sortBy: parsed?.sortBy || "default",
        };
    } catch {
        return { viewMode: "operational", sortBy: "default" };
    }
}

// Define role-based navigation links, can update which links show up for each user here.
const roleNavLinks = {
    1: [
        // Valet
        { to: "/addVehicle", label: "Check-In-Vehicle" },
        { to: "/valetDashBoard", label: "Queue" },
        { to: "/garage", label: "Garage" },
        { to: "/garage?transferAll=true", label: "Transfer All" },
        { to: "/validations/redeem", label: "Validate" },
        { to: "/tips/electronic", label: "Electronic Tip" },
        { to: "/updateProfile", label: "Profile" },
        { to: "/settings", label: "Settings" },
        { to: "/", label: "Home" },
        { to: "/selectPodium", label: "Active Podium" },
    ],
    2: [
        // Supervisor
        { to: "/addVehicle", label: "Check-In-Vehicle" },
        { to: "/valetDashBoard", label: "Valet Queue" },
        { to: "/garage", label: "Garage" },
        { to: "/garage?transferAll=true", label: "Transfer All" },
        { to: "/validations/redeem", label: "Validate" },
        { to: "/tips/electronic", label: "Electronic Tip" },
        { to: "/updateProfile", label: "Profile" },
        { to: "/settings", label: "Settings" },
        { to: "/selectPodium", label: "Active Podium" },
        { to: "/", label: "Home" },
        { to: "/surveyGraph", label: "Surveys" },
        { to: "/graph", label: "Transactions" },
        { to: "/about", label: "About" },
        { to: "/dashboard", label: "Dashboard" },
        // { to: "/user/config", label: "User Config" },
        // { to: "/register", label: "User Fast Add" },
        // { to: "/admin/setup", label: "Locations Setup" },
        // { to: "/admin/tickets/print", label: "Create Tickets" },

        // { to: "/locations", label: "Locations" },
        // { to: "/privacy-sms-policy", label: "Privacy & SMS Policy" },
    ],
    3: [
        // Manager
        { to: "/addVehicle", label: "Check-In-Vehicle" },
        { to: "/valetDashBoard", label: "Queue" },
        { to: "/garage", label: "Garage" },
        { to: "/garage?transferAll=true", label: "Transfer All" },
        { to: "/validations/redeem", label: "Validate" },
        { to: "/tips/electronic", label: "Electronic Tip" },
        { to: "/updateProfile", label: "Profile" },
        { to: "/settings", label: "Settings" },
        { to: "/selectPodium", label: "Active Podium" },
        { to: "/", label: "Home" },
        { to: "/surveyGraph", label: "Surveys" },
        { to: "/graph", label: "Transactions" },
        { to: "/about", label: "About" },
        { to: "/dashboard", label: "Dashboard" },
        { to: "/user/config", label: "User Config" },
        // { to: "/payments/config", label: "Payment Config" },
        { to: "/payments/reports", label: "Payment Reports" },
        { to: "/validations/tenants", label: "Validation Setup" },
        { to: "/validations/reports", label: "Validation Reports" },
        { to: "/register", label: "User Fast Add" },
        { to: "/admin/setup", label: "Locations Setup" },
        { to: "/admin/tickets/print", label: "Create Tickets" },

        // { to: "/locations", label: "Locations" },
        // { to: "/privacy-sms-policy", label: "Privacy & SMS Policy" },
    ],
    4: [
        //Director
        { to: "/addVehicle", label: "Check-In-Vehicle" },
        { to: "/valetDashBoard", label: "Queue" },
        { to: "/garage", label: "Garage" },
        { to: "/garage?transferAll=true", label: "Transfer All" },
        { to: "/validations/redeem", label: "Validate" },
        { to: "/updateProfile", label: "Profile" },
        { to: "/settings", label: "Settings" },
        { to: "/selectPodium", label: "Active Podium" },
        { to: "/", label: "Home" },
        { to: "/surveyGraph", label: "Surveys" },
        { to: "/graph", label: "Transactions" },
        { to: "/about", label: "About" },
        { to: "/dashboard", label: "Dashboard" },
        { to: "/user/config", label: "User Config" },
        { to: "/payments/config", label: "Payment Config" },
        { to: "/payments/reports", label: "Payment Reports" },
        { to: "/validations/tenants", label: "Validation Setup" },
        { to: "/validations/reports", label: "Validation Reports" },
        { to: "/register", label: "User Fast Add" },
        { to: "/admin/setup", label: "Locations Setup" },
        { to: "/admin/tickets/print", label: "Create Tickets" },

        // { to: "/locations", label: "Locations" },
        // { to: "/privacy-sms-policy", label: "Privacy & SMS Policy" },
    ],
    5: [
        // Admin
        { to: "/addVehicle", label: "Check-In-Vehicle" },
        { to: "/valetDashBoard", label: "Queue" },
        { to: "/garage", label: "Garage" },
        { to: "/garage?transferAll=true", label: "Transfer All" },
        { to: "/validations/redeem", label: "Validate" },
        { to: "/updateProfile", label: "Profile" },
        { to: "/settings", label: "Settings" },
        { to: "/selectPodium", label: "Active Podium" },
        { to: "/", label: "Home" },
        { to: "/surveyGraph", label: "Surveys" },
        { to: "/graph", label: "Transactions" },
        { to: "/about", label: "About" },
        { to: "/dashboard", label: "Dashboard" },
        { to: "/user/config", label: "User Config" },
        { to: "/payments/config", label: "Payment Config" },
        { to: "/payments/reports", label: "Payment Reports" },
        { to: "/validations/tenants", label: "Validation Setup" },
        { to: "/validations/reports", label: "Validation Reports" },
        { to: "/register", label: "User Fast Add" },
        { to: "/admin/setup", label: "Locations Setup" },
        { to: "/admin/tickets/print", label: "Create Tickets" },

        // { to: "/locations", label: "Locations" },
        // { to: "/privacy-sms-policy", label: "Privacy & SMS Policy" },
    ],
};

const tenantPortalNavLinks = [
    { to: "/tenant/portal", label: "Portal Home" },
    { to: "/validations/redeem", label: "Validate Ticket" },
    { to: "/validations/tenants", label: "Print Labels" },
    { to: "/validations/reports", label: "Usage History" },
];

const publicNavLinks = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },
    { to: "/login", label: "Login" },
    { to: "/registerWithInvite", label: "Register" },
];

function getLinkSection(link) {
    const to = String(link?.to || "");

    if (to === "/addVehicle" || to === "/valetDashBoard" || to === "/garage" || to === "/garage?transferAll=true" || to === "/validations/redeem" || to === "/tips/electronic" || to === "/selectPodium" || to === "/tenant/portal") {
        return "Operations";
    }

    if (to === "/dashboard" || to === "/surveyGraph" || to === "/graph" || to === "/payments/reports" || to === "/validations/reports") {
        return "Insights";
    }

    if (to === "/user/config" || to === "/payments/config" || to === "/validations/tenants" || to === "/register" || to === "/admin/setup" || to === "/admin/tickets/print" || to === "/admin/invite" || to === "/settings" || to === "/addRegion" || to === "/addLocation" || to === "/addPodium") {
        return "Admin";
    }

    return "Account";
}

function groupLinksBySection(links) {
    return links.reduce(
        (acc, link) => {
            const section = getLinkSection(link);
            if (!acc[section]) acc[section] = [];
            acc[section].push(link);
            return acc;
        },
        { Operations: [], Insights: [], Admin: [], Account: [] },
    );
}

function getPushStatusBadge(pushNotificationStatus) {
    const supported = Boolean(pushNotificationStatus?.supported);
    const enabled = Boolean(pushNotificationStatus?.enabled);
    const subscribed = Boolean(pushNotificationStatus?.subscribed);
    const permission = String(pushNotificationStatus?.permission || "default").toLowerCase();

    if (!supported) {
        return { label: "Push Alerts: Unsupported", toneClass: "is-neutral", action: null };
    }

    if (!enabled) {
        return { label: "Push Alerts: Off", toneClass: "is-neutral", action: null };
    }

    if (permission === "denied") {
        return { label: "Push Alerts: Blocked", toneClass: "is-danger", action: null };
    }

    if (subscribed) {
        return { label: "Push Alerts: On", toneClass: "is-ok", action: null };
    }

    if (permission === "granted") {
        return { label: "Push Alerts: Connecting", toneClass: "is-warn", action: null };
    }

    return { label: "Enable Push Alerts", toneClass: "is-warn", action: "enable" };
}

const NavHead = () => {
    const location = useLocation();
    const { token, userDetail, logout, activeLocationId, activePodiumId, pushNotificationStatus, enablePushNotifications } = useContext(UserContext);
    const { settings, setThemeMode } = useAppSettings();
    const [menuOpen, setMenuOpen] = useState(false);
    const [openSections, setOpenSections] = useState({
        Operations: false,
        Insights: false,
        Admin: false,
        Account: false,
    });
    const [logoLoadError, setLogoLoadError] = useState(false);
    const [activePodiumName, setActivePodiumName] = useState("");
    const [garageScopeText, setGarageScopeText] = useState("");
    const [isPaymentsFeatureEnabled, setIsPaymentsFeatureEnabled] = useState(false);

    const userTimeZone = userDetail?.userTimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
    const isGaragePath = location.pathname.startsWith("/garage") || location.pathname.startsWith("/transactions");

    useEffect(() => {
        setMenuOpen(false);
    }, [token, location.pathname]);

    useEffect(() => {
        let isMounted = true;

        async function fetchPaymentsFeatureStatus() {
            const roleId = Number(userDetail?.roleId || 0);

            if (!token || roleId < 1 || roleId >= 5) {
                if (isMounted) setIsPaymentsFeatureEnabled(true);
                return;
            }

            try {
                const res = await ValetApi.getPaymentsFeatureStatus();
                if (isMounted) {
                    setIsPaymentsFeatureEnabled(Boolean(res?.data?.featureEnabled === true));
                }
            } catch {
                if (isMounted) {
                    setIsPaymentsFeatureEnabled(false);
                }
            }
        }

        fetchPaymentsFeatureStatus();

        return () => {
            isMounted = false;
        };
    }, [token, userDetail?.roleId]);

    useEffect(() => {
        const resolvedLogo = resolveBrandLogoUrl(settings?.branding?.logoUrl || "");
        if (resolvedLogo) {
            setLogoLoadError(false);
        }
    }, [settings?.branding?.logoUrl]);

    useEffect(() => {
        let isMounted = true;

        async function fetchPodiumName() {
            if (!activePodiumId) {
                if (isMounted) setActivePodiumName("");
                return;
            }
            try {
                const res = await ValetApi.getPodiumById(activePodiumId);
                if (isMounted) setActivePodiumName(res?.data?.podium?.name || "");
            } catch {
                if (isMounted) setActivePodiumName("");
            }
        }

        fetchPodiumName();
        return () => {
            isMounted = false;
        };
    }, [activePodiumId]);

    useEffect(() => {
        function refreshGarageScopeText() {
            const date = new Intl.DateTimeFormat("en-US", {
                timeZone: userTimeZone,
                month: "short",
                day: "numeric",
            }).format(new Date());
            const { viewMode, sortBy } = readGarageFilterSummary();

            const viewMap = {
                operational: "Default",
                checked_out: "Checked-Out",
                all: "All",
            };

            const sortMap = {
                default: "Default",
                mobile: "Mobile",
                ticket: "Ticket",
                make: "Make",
                status: "Status",
                arrival: "Arrival",
                departure: "Departure",
            };

            setGarageScopeText(`${date} | ${viewMap[viewMode] || "Queue"} | ${sortMap[sortBy] || "Default"}`);
        }

        refreshGarageScopeText();
        window.addEventListener("garage-filters-changed", refreshGarageScopeText);
        window.addEventListener("storage", refreshGarageScopeText);

        return () => {
            window.removeEventListener("garage-filters-changed", refreshGarageScopeText);
            window.removeEventListener("storage", refreshGarageScopeText);
        };
    }, [userTimeZone, location.pathname]);

    function toggleMenu() {
        setMenuOpen((prev) => !prev);
    }

    function toggleSection(sectionName) {
        setOpenSections((prev) => ({
            ...prev,
            [sectionName]: !prev[sectionName],
        }));
    }

    async function handlePushBadgeAction(pushStatusBadge) {
        if (!pushStatusBadge || pushStatusBadge.action !== "enable") return;
        if (typeof enablePushNotifications !== "function") return;
        await enablePushNotifications();
    }

    function resolveLinkIsActive(linkTo) {
        const normalizedTo = String(linkTo || "");

        if (normalizedTo === "/garage?transferAll=true") {
            return (_match, activeLocation) => {
                if (!activeLocation || activeLocation.pathname !== "/garage") return false;
                const params = new URLSearchParams(activeLocation.search || "");
                return params.get("transferAll") === "true";
            };
        }

        if (normalizedTo === "/garage") {
            return (_match, activeLocation) => {
                if (!activeLocation || activeLocation.pathname !== "/garage") return false;
                const params = new URLSearchParams(activeLocation.search || "");
                return params.get("transferAll") !== "true";
            };
        }

        return undefined;
    }

    function renderSidebar() {
        const isTenantPortal = Boolean(userDetail?.isTenantPortal);
        const isAuthenticated = Boolean(token);
        const roleId = Number(userDetail?.roleId || 0);
        const useFlatNav = isAuthenticated && !isTenantPortal && roleId === 1;
        const baseLinks = isAuthenticated ? (isTenantPortal ? tenantPortalNavLinks : roleNavLinks[userDetail?.roleId] || roleNavLinks[1]) : publicNavLinks;
        const hidePaymentLinks = !isTenantPortal && roleId > 0 && roleId < 5 && !isPaymentsFeatureEnabled;
        const links = baseLinks.filter((link) => {
            if (!isTenantPortal && roleId === 1 && !isPaymentsFeatureEnabled && link.to === "/validations/redeem") {
                return false;
            }

            if (hidePaymentLinks && String(link.to || "").startsWith("/payments")) {
                return false;
            }

            return true;
        });
        const groupedLinks = isAuthenticated ? groupLinksBySection(links) : { Menu: links };
        const branding = settings?.branding || {};
        const resolvedLogoUrl = resolveBrandLogoUrl(branding.logoUrl);
        const showLogoImage = branding.logoType === "image" && String(resolvedLogoUrl || "").trim().length > 0 && !logoLoadError;
        const brandText = String(branding.brandText || "ParkPilot").trim() || "ParkPilot";
        const mobileBrandTarget = isAuthenticated ? (isTenantPortal ? "/tenant/portal" : "/valetDashBoard") : "/";

        const activeLocationName = userDetail?.accessibleLocations?.find((l) => Number(l.id) === Number(activeLocationId))?.name || userDetail?.accessibleLocations?.[0]?.name || "";
        const navPillName = activePodiumName || activeLocationName;
        const showPushBadge = isAuthenticated && !isTenantPortal && Number(roleId || 0) >= 1 && Number(roleId || 0) <= 5;
        const pushStatusBadge = showPushBadge ? getPushStatusBadge(pushNotificationStatus) : null;

        return (
            <>
                <NavLink
                    exact
                    to={mobileBrandTarget}
                    className="sidebar-mobile-brand"
                    onClick={() => setMenuOpen(false)}>
                    {showLogoImage ? (
                        <img
                            src={resolvedLogoUrl}
                            alt={brandText}
                            className="sidebar-brand-logo"
                            onError={() => setLogoLoadError(true)}
                        />
                    ) : null}
                    <span className="sidebar-brand-text">{brandText}</span>
                </NavLink>

                <button
                    type="button"
                    className="sidebar-mobile-toggle"
                    onClick={toggleMenu}
                    aria-label="Open navigation">
                    ☰
                </button>

                <div
                    className={`sidebar-overlay${menuOpen ? " active" : ""}`}
                    onClick={() => setMenuOpen(false)}
                />

                <aside className={`app-sidebar${menuOpen ? " open" : ""}`}>
                    <NavLink
                        exact
                        to={isAuthenticated ? (isTenantPortal ? "/tenant/portal" : "/valetDashBoard") : "/"}
                        className="sidebar-brand">
                        {showLogoImage ? (
                            <img
                                src={resolvedLogoUrl}
                                alt={brandText}
                                className="sidebar-brand-logo"
                                onError={() => setLogoLoadError(true)}
                            />
                        ) : null}
                        <span className="sidebar-brand-text">{brandText}</span>
                    </NavLink>

                    {isAuthenticated ? (
                        <div className="sidebar-meta-stack">
                            {navPillName ? <span className="sidebar-pill">{navPillName}</span> : null}
                            {isGaragePath && garageScopeText ? <span className="sidebar-pill sidebar-pill-subtle">{garageScopeText}</span> : null}
                            {pushStatusBadge ? (
                                pushStatusBadge.action ? (
                                    <button
                                        type="button"
                                        className={`sidebar-system-chip is-action ${pushStatusBadge.toneClass}`}
                                        onClick={() => handlePushBadgeAction(pushStatusBadge)}>
                                        {pushStatusBadge.label}
                                    </button>
                                ) : (
                                    <span className={`sidebar-system-chip ${pushStatusBadge.toneClass}`}>{pushStatusBadge.label}</span>
                                )
                            ) : null}
                        </div>
                    ) : null}

                    <div className="sidebar-links-wrap">
                        {useFlatNav
                            ? links.map((link, idx) => (
                                  <NavLink
                                      key={`flat-${idx}`}
                                      exact
                                      to={link.to}
                                      className="sidebar-link"
                                      activeClassName="active"
                                      isActive={resolveLinkIsActive(link.to)}
                                      onClick={() => setMenuOpen(false)}>
                                      {link.label}
                                  </NavLink>
                              ))
                            : Object.entries(groupedLinks).map(([sectionName, sectionLinks]) => {
                                  if (!sectionLinks.length) return null;
                                  const isOpen = openSections[sectionName] ?? true;

                                  return (
                                      <div
                                          key={sectionName}
                                          className={`sidebar-section${isOpen ? " is-open" : ""}`}>
                                          {isAuthenticated ? (
                                              <button
                                                  type="button"
                                                  className="sidebar-section-toggle"
                                                  onClick={() => toggleSection(sectionName)}>
                                                  <span>{sectionName}</span>
                                                  <span className="sidebar-section-caret">{isOpen ? "-" : "+"}</span>
                                              </button>
                                          ) : (
                                              <div className="sidebar-section-title">{sectionName}</div>
                                          )}

                                          {isOpen
                                              ? sectionLinks.map((link, idx) => (
                                                    <NavLink
                                                        key={`${sectionName}-${idx}`}
                                                        exact
                                                        to={link.to}
                                                        className="sidebar-link"
                                                        activeClassName="active"
                                                        isActive={resolveLinkIsActive(link.to)}
                                                        onClick={() => setMenuOpen(false)}>
                                                        {link.label}
                                                    </NavLink>
                                                ))
                                              : null}
                                      </div>
                                  );
                              })}
                    </div>

                    {isAuthenticated && isTenantPortal ? (
                        <FormGroup className="px-3 mt-3">
                            <Label for="tenantThemeMode">Theme</Label>
                            <Input
                                id="tenantThemeMode"
                                type="select"
                                value={settings.themeMode}
                                onChange={(event) => setThemeMode(event.target.value)}>
                                <option value="auto">System</option>
                                <option value="light">Light</option>
                                <option value="dark">Dark</option>
                            </Input>
                        </FormGroup>
                    ) : null}

                    {isAuthenticated ? (
                        <button
                            type="button"
                            className="sidebar-logout"
                            onClick={logout}>
                            Logout ~ {userDetail?.firstName}
                        </button>
                    ) : null}
                </aside>
            </>
        );
    }

    return renderSidebar();
};

export default NavHead;
